import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getMetaTags } from 'services/app';

export interface MetaTagsResponse {
  title: string;
  description: string;
  img_url: string;
  message?: string;
}

export default function useMetaTags(
  url: string,
  options?: Omit<UseQueryOptions<MetaTagsResponse, Error, MetaTagsResponse, QueryKey>, 'queryKey'>
) {
  return useQuery<MetaTagsResponse, Error>(
    [`meta-tags`, url],
    () =>
      getMetaTags(url).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError.message);
        }

        if (response.data && response.data.message === 'metatags empty') {
          throw new Error('metatags empty');
        }

        if (response.data && response.data.message === 'something went wrong') {
          throw new Error('metatags empty');
        }

        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
